<template>
  <section class="flex flex-col justify-center items-center h-fit w-fit">
    <div class="x-reset-container">
      <div class="c-leaf">
        <svg
          version="1.1"
          class="c-leaf__icon"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 100 100"
          style="enable-background: new 0 0 100 100"
          xml:space="preserve"
        >
          <g class="c-leaf__icon-group">
            <path
              class="st0"
              d="M-1.3-1.3v102.5h102.5V-1.3H-1.3z M10.7,23.9c0.7-6.5,3.8-12.5,8.8-16.8c4.2-3.7,9.8-5.8,15.5-5.7l3.4,11.4
	L6,57.8L10.7,23.9z M90.3,70.5c-1.3,9.9-4.7,17.1-10,21.7C74.9,96.7,67.2,99,57.1,99H30.5l0.5-3.5l21.4-39.3
	c0.9-1.8,1.8-3.6,2.7-5.4c0.9-1.8,1.8-3.7,2.9-5.5c1.8-3.3,4-6.3,6.7-8.7c2.3-2.2,5.9-3.3,10.7-3.3l1.1-7.8
	c-5.7-0.2-11.4,1.6-16.1,5c-1.8,1.4-3.3,3-4.7,4.8c-1.8,2.2-3.4,4.6-4.8,7L47,49.6l-3.9,7.3l-14.5,27c-2.2,4.6-5.6,8.6-9.7,11.6
	C15.5,97.8,10.8,99,4.8,99H0.1l3.8-26.7L41,20.6h0.2c0.5-0.9,1.1-1.8,1.7-2.6l0.3-0.4c3.6-5.5,8.6-9.9,14.5-12.8
	C62.5,2.6,69,1.5,77.1,1.5H100L90.3,70.5z"
            />
          </g>
        </svg>
        <div class="c-leaf__fill" :style="{ height: fillHeight }"></div>
      </div>
    </div>
    <h2 class="text-primary-700 text-2xl mt-[20px]">
      טוען {{ loadingProgress }}%
    </h2>
  </section>
</template>

<script>
export default {
  name: "Loader",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      progress: 0,
      duration: 2500, // in milliseconds
    };
  },
  computed: {
    fillHeight() {
      return `${100 - this.progress}%`;
      1;
    },
    loadingProgress() {
      return this.progress;
    },
  },
  watch: {
    // isLoading(newVal) {
    //   if (newVal) {
    //     this.startLoader();
    //   } else {
    //     this.completeLoader();
    //   }
    // }
  },
  mounted() {
    this.startLoader();
  },
  methods: {
    startLoader() {
      this.progress = 0;
      const interval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 1;
        } else {
          this.completeLoader();
          clearInterval(interval);
        }
      }, this.duration / 100);

      // Trigger the animation by adding a class
      const leafFill = this.$el.querySelector(".c-leaf__fill");
      leafFill.classList.add("fill-animation");
    },
    completeLoader() {
      this.$emit("loading-complete");
    },
  },
};
</script>

<style lang="scss">
$main-background-color: #fff;
$leaf-empty-color: #3f238b;
$leaf-fill-color: #eee;

$leaf-width: 64px;
$leaf-height: 64px;

$leaf-size: 1;
$leaf-time: 2.5s;

.c-leaf {
  position: relative;
  overflow: hidden;
  width: #{$leaf-width - 2px};
  height: #{$leaf-height - 2px};
  margin: 0 auto;
  background: $leaf-empty-color;
  transform: scale($leaf-size);
}

.c-leaf__icon {
  position: absolute;
  top: -2px;
  left: 0;
  z-index: 1;
  width: $leaf-width;
  height: $leaf-height;
  fill: $main-background-color;
}

.c-leaf__fill {
  width: $leaf-width;
  height: $leaf-height;
  background: $leaf-fill-color;
  overflow: hidden;
}

.fill-animation {
  animation: fillUp $leaf-time ease-in-out forwards;
}

@keyframes fillUp {
  0% {
    height: 100%;
  }
  100% {
    height: 0;
  }
}

.x-reset-container {
  display: flex;
  align-items: center;
}

.loading-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #000;
}
</style>